import {
  FormControl,
  FormGroup,
  FormBuilder,
  Validators,
  FormGroupDirective,
  FormArray,
  AbstractControl, ValidationErrors, ValidatorFn
} from "@angular/forms";
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, ViewChild, Inject,Renderer2 } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { inject } from 'underscore';
import Swal from 'sweetalert2/dist/sweetalert2.all.js'; // CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

import { ServicioGestionCargueService } from '../../servicios/servicio-gestion-cargue.service';
import * as internal from 'assert';

@Component({
  selector: 'app-dialogo-gestion-cargue',
  templateUrl: './dialogo-gestion-cargue.component.html',
  styleUrls: ['./dialogo-gestion-cargue.component.css']
})
export class DialogoGestionCargueComponent implements OnInit {
  @ViewChild(FormGroupDirective,{static: false})
  formGroupDirective: FormGroupDirective;
  
  CurrUsuarioConsulta = 0;

  entregaAct: any;
  dataSalida: any;

  dataMotivos=[];
  dataPaquetes=[];

  idNovedad=0;

  controlesGroup: FormGroup;
  controlPaqueteMotivo = new FormArray([]);

  constructor(
    public dialogRef: MatDialogRef<DialogoGestionCargueComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any,
    private formBuilder:FormBuilder,
    private servicioGestionCargue: ServicioGestionCargueService
  ) { 
    
    const infoUsuario = JSON.parse(sessionStorage.getItem("infoUsuario"));
    this.CurrUsuarioConsulta = infoUsuario[0].IdUsuario;
    
    this.controlesGroup = this.formBuilder.group({
      Observaciones: ['', Validators.required],
      RbgNovedad:[0,Validators.required]
    }/*,{ updateOn: "blur" }*/);

  }

  ngOnInit() {
    this.entregaAct=this.data.entrega;
    console.log(this.data);
    this.CargarMotivos();
    this.CargarPaquetes();
    console.log(this.entregaAct);
  }

CargarMotivos(){
  Swal.fire({
    title: 'Cargando datos !',
    html: 'Un momento por favor.',// add html attribute if you want or remove
    allowOutsideClick: false,
    allowEscapeKey: false,
    showCancelButton: false,
    showConfirmButton: false,
    onBeforeOpen () {
      Swal.showLoading ()
    },
    // willOpen: () => {
    //   Swal.showLoading();
    // },
  });
this.servicioGestionCargue.MotivosConsultar(3).subscribe(
  (data: any) => {
    Swal.close();
    this.dataMotivos=data;
  }
);
  

}
CargarPaquetes(){
  Swal.fire({
    title: 'Cargando datos !',
    html: 'Un momento por favor.',// add html attribute if you want or remove
    allowOutsideClick: false,
    allowEscapeKey: false,
    showCancelButton: false,
    showConfirmButton: false,
    onBeforeOpen () {
      Swal.showLoading ()
    },
    // willOpen: () => {
    //   Swal.showLoading();
    // },
  });
this.servicioGestionCargue.PaquetesConsultar(this.entregaAct.idServicioEnc).subscribe(
  (data: any) => {
    Swal.close();
    this.dataPaquetes=data;
    for(let i=0;i < this.dataPaquetes.length; i++ ){
      this.controlesGroup.addControl("ctrl_" + this.dataPaquetes[i].idServicioPaquete , new FormControl(null, [Validators.required,,this.customValidator()]))
      // this.controlPaqueteMotivo.push(
        
      // );
    }
  }
);
}

private customValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const valid: boolean = (this.idNovedad==1 && control.value ==31 || (this.idNovedad==2 && control.value !=0 ));
    console.log(valid);
    return valid ? null : { amountMinError: true };
  };
}

public setMotivo(){
  let valueMotivo=0;
  valueMotivo=this.idNovedad==1? 31 : 0;
  for(let i=0;i < this.dataPaquetes.length; i++ ){
    this.controlesGroup.get("ctrl_" + this.dataPaquetes[i].idServicioPaquete).setValue(valueMotivo);
  }
}

public terminarGestionCargue(){
  let gestion;
  let paquetesGestion=[];
  for(let i=0;i < this.dataPaquetes.length; i++ ){
    let paquete={
      idServicioPaquete: this.dataPaquetes[i].idServicioPaquete,
      idMotivo:this.idNovedad==1? 1 :  this.controlesGroup.get("ctrl_" + this.dataPaquetes[i].idServicioPaquete).value,
      cantidadFinal : 0
    }
    paquetesGestion.push(paquete);
  }
  gestion={
    idUsuarioConsulta:this.CurrUsuarioConsulta,
    idServicioEnc:this.entregaAct.idServicioEnc,
    idMotivo:this.idNovedad == 1 ? 1 : 14,
    idTpoNovedad:this.idNovedad,
    observaciones: this.controlesGroup.get("Observaciones").value,
    paquetes: paquetesGestion
  }
  Swal.fire({
    title: 'Guardando datos !',
    html: 'Un momento por favor.',// add html attribute if you want or remove
    allowOutsideClick: false,
    allowEscapeKey: false,
    showCancelButton: false,
    showConfirmButton: false,
    onBeforeOpen () {
      Swal.showLoading ();
    },
    // willOpen: () => {
    //   Swal.showLoading();
    // },
  });

  this.servicioGestionCargue
  .EntregaGuardar(gestion)
  .subscribe(() => {
    Swal.close();
    Swal.fire({
      title: "Cargue Guardado",
      text: "Se ha guardado el cargue con exito.",
      type: "success",
      confirmButtonColor: '#127570',
      allowOutsideClick: false,
    }).then((result) => {
      this.enviarEntregaEorder(this.entregaAct.idUsuarioAsignado);
    }
    );
  }
  );

}



public enviarEntregaEorder(idUsuario){


  Swal.fire({
  title: 'Enviando a EORDER !',
    html: 'Un momento por favor.',// add html attribute if you want or remove
    allowOutsideClick: false,
    allowEscapeKey: false,
    showCancelButton: false,
    showConfirmButton: false,
    onBeforeOpen () {
      Swal.showLoading ();
    },
    // willOpen: () => {
    //   Swal.showLoading();
    // },
  });

  const link = document.createElement("a");
  link.setAttribute("target", "_blank");
  link.setAttribute("href", "http://18.210.107.20/cncaldas_bifrost_qa/api/DataBaseSync/Respaldo/un/"+ idUsuario +"/amb/300");
  //link.setAttribute("download",tipo + consecutivoSiigo + ".xlsx");
  document.body.appendChild(link);
  link.click();
  link.remove();


  Swal.close();
    Swal.fire({
      title: "Cargue Enviado",
      text: "Se ha Enviado el cargue por favor verifique el resultado de la transacción.",
      type: "warning",
      confirmButtonColor: '#127570',
      allowOutsideClick: false,
    }).then((result) => {
      if (result.value) {
        this.dataSalida = {
          resultado: 'OK',
        };
        this.dialogRef.close(this.dataSalida);
      }
    }
    );

  // this.servicioGestionCargue
  // .EntregasProcesar(idUsuario)
  // .subscribe(() => {
    
  // }
  // );



  
}
  cancelar(){
    this.dataSalida = {
      resultado: 'KO',
    };
    this.dialogRef.close(this.dataSalida);
  }
}
